import { createTheme } from '@mantine/core';

export const shadows = createTheme({
  shadows: {
    md: '0 2px 2px 0 rgba(0, 0, 0, 0.08)',
    dark: '0px 4px 15px 0px #161D2526',
  },
});
